<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="lat" [ttModel]="edit.lat" ttReadonly></tt-input>
        <tt-input ttLabel="lng" [ttModel]="edit.lng" ttReadonly></tt-input>
        <tt-input ttLabel="gisposition_name" [(ttModel)]="edit.gisposition_name" ttRequired></tt-input>
        <tt-editor ttLabel="gisposition_note" [(ttModel)]="edit.gisposition_note" [(ttProcessing)]="readyGisPositionNote"></tt-editor>
        <tt-button-save ttText="gispositionadd_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
